import type {
  Crm, EmailMarketing, FulfilmentTool, GroupKey, Helpdesk, ItemHistoryAction, ItemNetwork, ItemState, Network, OnboardingBrand, OnboardingStage, Party, Processor, RefundPlatform, SubscriptionApp,
} from "../../types/onboarding";

export const PROCESSOR_LABELS: Record<Processor, string> = {
  shopify_payments: "Shopify Payments",
  stripe: "Stripe",
  paypal: "PayPal",
  adyen: "Adyen",
  nmi: "NMI",
  other: "Other",
};

export function toOtherProcessorNames(brands: OnboardingBrand[]): string[] {
  return [...new Set(brands.flatMap((b) => (b.processors.includes("other") ? b.otherProcessorNames ?? [] : [])))];
}

export const NETWORK_LABELS: Record<Network, string> = { ethoca: "Ethoca", cdrn: "Verifi CDRN", rdr: "Verifi RDR" };

export const CRM_LABELS: Record<Crm, string> = { shopify: "Shopify", checkoutchamp: "CheckoutChamp", other: "Other", not_sure: "Not sure" };

export const REFUND_PLATFORM_LABELS: Record<RefundPlatform, string> = { none: "None", shopify: "Shopify", checkoutchamp: "CheckoutChamp", other: "Other", not_sure: "Not sure" };

export const SUBSCRIPTION_APP_LABELS: Record<SubscriptionApp, string> = {
  none: "None",
  loop: "Loop",
  kaching: "Kaching",
  skio: "Skio",
  recharge: "Recharge",
  checkoutchamp: "CheckoutChamp",
  other: "Other",
  not_sure: "Not sure",
};

export const HELPDESK_LABELS: Record<Helpdesk, string> = {
  none: "None",
  zendesk: "Zendesk",
  richpanel: "Richpanel",
  gorgias: "Gorgias",
  commslayer: "CommsLayer",
  intercom: "Intercom",
  gmail: "Gmail",
  other: "Other",
  not_sure: "Not sure",
};

export const FULFILMENT_LABELS: Record<FulfilmentTool, string> = {
  shipstation: "ShipStation",
  shipsidekick: "ShipSidekick",
  shipoffers: "ShipOffers",
  jetpack: "Jetpack Shipping",
  ecomflow: "EcomFlow",
  packiyo: "Packiyo",
  dayone: "Day One Fulfillment",
  oneclick: "OneClick Dropshipping",
  shopify: "Shopify",
  other: "Other",
  not_sure: "Not sure",
};

export const EMAIL_MARKETING_LABELS: Record<EmailMarketing, string> = { none: "None", klaviyo: "Klaviyo", omnisend: "Omnisend", other: "Other", not_sure: "Not sure" };

export const GROUP_LABELS: Record<GroupKey, string> = {
  billing: "Billing and portal",
  processors: "Payment processors",
  crm: "CRM and apps",
  refunds: "Refunds",
  enrolments: "Alert enrolments",
  representment: "Chargeback representment",
  golive: "Go-live",
  custom: "Other steps",
};

const PARTY_LABELS: Record<Exclude<Party, "network">, string> = { client: "Client", us: "Us" };

export const ITEM_NETWORK_LABELS: Record<ItemNetwork, string> = { chargebackhelp: "Ethoca", verifi: "Verifi" };

export const ITEM_STATE_LABELS: Record<ItemState, string> = { todo: "To do", waiting: "Waiting", done: "Done", not_needed: "Not needed" };

export const HISTORY_ACTION_LABELS: Record<ItemHistoryAction, string> = {
  asked: "asked the client",
  sent: "sent it to the network",
  chased: "chased",
  done: "marked it done",
  live: "marked it live",
  not_needed: "marked it not needed",
  retired_by_edit: "marked it not needed when the answers changed",
  reopened: "reopened it",
  reopened_by_edit: "reopened it when the answers changed",
  back_to_todo: "moved it back to To do",
  notes: "updated the notes",
  details: "updated the details",
  added: "added the step",
};

export const partyLabel = (item: { party: Party; network: ItemNetwork | null }) =>
  item.party === "network" ? ITEM_NETWORK_LABELS[item.network as ItemNetwork] : PARTY_LABELS[item.party];

export const STAGES: Record<OnboardingStage, { label: string; color: "light" | "primary" | "success" }> = {
  new: { label: "New", color: "light" },
  setting_up: { label: "Setting up", color: "primary" },
  done: { label: "Done", color: "success" },
};
